import { Component, Inject } from '@angular/core';

import { MatIcon } from '@angular/material/icon';
import { MAT_SNACK_BAR_DATA, MatSnackBarRef } from '@angular/material/snack-bar';
import { IAlertData } from '../../typing/messages.interface';
import { NgClass } from '@angular/common';

@Component({
    selector: 'app-alert-message',
    standalone: true,
    imports: [MatIcon, NgClass],
    templateUrl: './alert-message.component.html',
    styleUrl: './alert-message.component.scss',
})
export class AlertMessageComponent {
    constructor(
        @Inject(MAT_SNACK_BAR_DATA) public data: IAlertData,
        public snackBarRef: MatSnackBarRef<AlertMessageComponent>,
    ) {}

    closeSnackbar(): void {
        this.snackBarRef.dismiss(); // Закрытие снекбара вручную
    }
}
